import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';
import SelectAsync from 'react-select/async';
import NumberFormat from 'react-number-format';

export default class InsuranceTaxSettings extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/insurancetaxsettings/get", {
            id: this.getCurrentFormId()
        }).then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }



    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/insurancetaxsettings/save", {
            isLeave: this.state.data.record.isLeave,
            workingHoursMonths: this.state.data.record.workingHoursMonths,
            workingHoursDays: this.state.data.record.workingHoursDays,
            priceInsurance: this.state.data.record.priceInsurance,
            taxCalculation: this.state.data.record.taxCalculation,
            eidCeiling: this.state.data.record.eidCeiling,
            eidExemptionAmount: this.state.data.record.eidExemptionAmount,
            exemptionAmountNonCash: this.state.data.record.exemptionAmountNonCash,
            isFGhInsurance: this.state.data.record.isFGhInsurance,
            proccessPay: this.state.data.record.proccessPay,
            hpTotalCode: this.state.data.record.hpTotalCode,
            hpGivenCode: this.state.data.record.hpGivenCode,
            hbTotalCode: this.state.data.record.hbTotalCode,
            hbGivenCode: this.state.data.record.hbGivenCode,
            hbPreferenceCode:this.state.data.record.hbPreferenceCode


        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    taxCalculation(id) {
        this.state.data.record.taxCalculation = id;
    }
    proccessPay(id) {
        this.state.data.record.proccessPay = id;
    }
    AccountTotalCode(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/settingco/getaccounttotalcode/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    AccountGivenCode(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/settingco/getaccountgivencode/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    AccountPerferenceCode(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/settingco/getaccountpreferencecode/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    renderForm() {
        return <div className="container-fluid">
            <div className="nk-content-inner">
                <div className="nk-content-body">
                    <div className="components-preview wide-md mx-auto">
                        <div className="nk-block-head nk-block-head-lg wide-sm">
                            <div className="nk-block-head-content">
                                <div className="nk-block-head-sub">
                                    <NavLink className="back-to" to="/home/"><em className="icon ni ni-arrow-left"></em><span>داشبورد</span></NavLink>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <form method="post" onSubmit={e => this.save(e)} novalidate="novalidate">
                                <div className="nk-block nk-block-lg">
                                    <div className="card card-bordered">
                                        <div className="card-aside-wrap">
                                            <div className="card-inner card-inner-lg">
                                                <div className="nk-block-head nk-block-head-lg">
                                                    <div className="nk-block-between">
                                                        <div className="nk-block-head-content">
                                                            <span>این تنظیمات مبالغ ثابت جهت قرارداد.</span>

                                                        </div>

                                                        <div className="nk-block-head-content align-self-start d-lg-none">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="nk-block">
                                                    <div className="card-inner-group">

                                                        <div className="card-inner border border-gray bg-lighter text-dark">



                                                            <div class="between-center flex-wrap g-3 border">
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">مرخصی مازاد بر حق قانونی از روز کارکرد کسر شود؟</label>
                                                                        <div className="form-control-wrap">
                                                                            <div className="custom-control custom-switch">
                                                                                <input type="checkbox" className="custom-control-input" defaultChecked={this.state.data.record.isLeave} onChange={e => this.state.data.record.isLeave = e.target.checked} id="customSwitch2" />
                                                                                <label className="custom-control-label" htmlFor="customSwitch2"> فعال</label>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">ساعت کار استاندارد ماهانه</label>
                                                                        <div className="form-control-wrap">

                                                                            <NumberFormat className="form-control" type="text" defaultValue={this.state.data.record.workingHoursMonths} onChange={e => this.state.data.record.workingHoursMonths = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, '')))} />

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">ساعت کار استانداردروزانه</label>
                                                                        <div className="form-control-wrap">
                                                                            <NumberFormat className="form-control" type="text" defaultValue={this.state.data.record.workingHoursDays} onChange={e => this.state.data.record.workingHoursDays = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, '')))} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">مبلغ سقف محاسبه بیمه</label>
                                                                        <div className="form-control-wrap">
                                                                            <NumberFormat thousandSeparator={true} className="form-control" type="text" defaultValue={this.state.data.record.priceInsurance} onChange={e => this.state.data.record.priceInsurance = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, '')))} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">نحوه محاسیه مالیات</label>
                                                                        <div className="form-control-wrap">
                                                                            <select className="form-control" defaultValue={this.state.data.record.taxCalculation} onChange={e => this.taxCalculation(parseInt(e.target.value))}>
                                                                                <option value="1">سطح سال </option>
                                                                                <option value="2">سطح ماه</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">سقف عیدی</label>
                                                                        <div className="form-control-wrap">

                                                                            <NumberFormat thousandSeparator={true} className="form-control" type="text" value={this.state.data.record.eidCeiling} onChange={e => this.state.data.record.eidCeiling = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, '')))} />

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">مبلغ معافیت عیدی</label>
                                                                        <div className="form-control-wrap">

                                                                            <NumberFormat thousandSeparator={true} className="form-control" type="text" value={this.state.data.record.eidExemptionAmount} onChange={e => this.state.data.record.eidExemptionAmount = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, '')))} />

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">میزان معافیت مزایای غیر نقدی</label>
                                                                        <div className="form-control-wrap">

                                                                            <NumberFormat thousandSeparator={true} className="form-control" type="text" value={this.state.data.record.exemptionAmountNonCash} onChange={e => this.state.data.record.exemptionAmountNonCash = (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, '')))} />

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">فوق العاده غیر مشمول بیمه مالیات در فیش حقوق و قرارداد لحاظ شود؟</label>
                                                                        <div className="form-control-wrap">
                                                                            <div className="custom-control custom-switch">
                                                                                <input type="checkbox" className="custom-control-input" defaultChecked={this.state.data.record.isFGhInsurance} onChange={e => this.state.data.record.isFGhInsurance = e.target.checked} id="customSwitch3" />
                                                                                <label className="custom-control-label" htmlFor="customSwitch3"> فعال</label>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-soft">نحوه محاسبه خالص پرداختی در صورت مغایرت مالیات</label>
                                                                        <div className="form-control-wrap">
                                                                            <select className="form-control" defaultValue={this.state.data.record.proccessPay} onChange={e => this.proccessPay(parseInt(e.target.value))}>
                                                                                <option value="1">مالیات محاسبه شده </option>
                                                                                <option value="2">مالیات پرداختی بخ سازمان</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <br/>
                                                            <div className="row g-3 border">
                                                                <div className="nk-block-head-content">
                                                                    <span>حقوق و دستمزد پرداختنی.</span>

                                                                </div>
                                                                <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">کد حساب کل </label>
                                                                        <div className="form-control-wrap">
                                                                            <SelectAsync
                                                                                defaultValue={this.state.data.record.hpTotalCode > 0 ? [{ value: this.state.data.record.hpTotalCode, label: this.state.data.record.hpTotalCodeText }] : null}
                                                                                isMulti={false}
                                                                                placeholder="کل"
                                                                                defaultOptions
                                                                                isSearchable
                                                                                loadOptions={this.AccountTotalCode}
                                                                                onChange={e => this.state.data.record.hpTotalCode = e.value}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">کد معین </label>
                                                                        <div className="form-control-wrap">
                                                                            <SelectAsync
                                                                                defaultValue={this.state.data.record.hpGivenCode > 0 ? [{ value: this.state.data.record.hpGivenCode, label: this.state.data.record.hpGivenCodeText }] : null}
                                                                                isMulti={false}
                                                                                placeholder="معین"
                                                                                defaultOptions
                                                                                isSearchable
                                                                                loadOptions={this.AccountGivenCode}
                                                                                onChange={e => this.state.data.record.hpGivenCode = e.value}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                               

                                                            </div>
                                                            <br />
                                                            <div className="row g-3 border">
                                                                <div className="nk-block-head-content">
                                                                    <span>حق بیمه پرداختنی کارکنان.</span>

                                                                </div>
                                                                <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">کد حساب کل </label>
                                                                        <div className="form-control-wrap">
                                                                            <SelectAsync
                                                                                defaultValue={this.state.data.record.hbTotalCode > 0 ? [{ value: this.state.data.record.hbTotalCode, label: this.state.data.record.hbTotalCodeText }] : null}
                                                                                isMulti={false}
                                                                                placeholder="کل"
                                                                                defaultOptions
                                                                                isSearchable
                                                                                loadOptions={this.AccountTotalCode}
                                                                                onChange={e => this.state.data.record.hbTotalCode = e.value}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">کد معین </label>
                                                                        <div className="form-control-wrap">
                                                                            <SelectAsync
                                                                                defaultValue={this.state.data.record.hbGivenCode > 0 ? [{ value: this.state.data.record.hbGivenCode, label: this.state.data.record.hbGivenCodeText }] : null}
                                                                                isMulti={false}
                                                                                placeholder="معین"
                                                                                defaultOptions
                                                                                isSearchable
                                                                                loadOptions={this.AccountGivenCode}
                                                                                onChange={e => this.state.data.record.hbGivenCode = e.value}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">کد تفضیل </label>
                                                                        <div className="form-control-wrap">
                                                                            <SelectAsync
                                                                                defaultValue={this.state.data.record.hbPreferenceCode > 0 ? [{ value: this.state.data.record.hbPreferenceCode, label: this.state.data.record.hbPreferenceCodeText }] : null}
                                                                                isMulti={false}
                                                                                placeholder="تفضیل"
                                                                                defaultOptions
                                                                                isSearchable
                                                                                loadOptions={this.AccountPerferenceCode}
                                                                                onChange={e => this.state.data.record.hbPreferenceCode = e.value}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>


                                                        <br />
                                                        <button className="btn btn-outline-success" type="submit" onClick={e => this.save(e)}>ثبت نهایی جداول مالیات</button>

                                                    </div>
                                                </div>

                                            </div>

                                            <div class="card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg toggle-screen-lg" data-toggle-body="true" data-content="userAside" data-toggle-screen="lg" data-toggle-overlay="true" style={{ backgroundColor: "#16498a" }}>
                                                <div class="card-inner-group" data-simplebar="init">
                                                    <div class="simplebar-wrapper" style={{ margin: '0px' }} >
                                                        <div class="simplebar-height-auto-observer-wrapper">
                                                            <div class="simplebar-height-auto-observer"></div>
                                                        </div>
                                                        <div class="simplebar-mask">
                                                            <div class="simplebar-offset" style={{ left: '0px', bottom: '0px' }} >
                                                                <div class="simplebar-content-wrapper" tabindex="0" role="region" aria-label="scrollable content" style={{ height: 'auto', overflow: 'hidden' }} >
                                                                    <div class="simplebar-content" style={{ padding: '0px' }} >
                                                                        <div class="card-inner">
                                                                            <h3 class="nk-block-title page-title text-white">تنظیمات</h3>
                                                                            <div class="nk-block-des text-soft text-white">
                                                                                <p className="text-white">در این قسمت مزایای شرکت خود را تعریف میکنید</p>
                                                                            </div>
                                                                        </div>

                                                                        <div class="card-inner p-0">
                                                                            <ul class="link-list-menu">
                                                                                <li>
                                                                                    <a class="active"  className="text-white" href="/ConfigCompany"><em class="icon ni ni-user-fill-c text-white"></em><span>مزایا</span></a>
                                                                                </li>
                                                                                <li>
                                                                                    <a href="/ConfigTax" className="text-white"><em class="icon ni ni-lock-alt-fill text-white"></em><span>جدول مالیات</span></a>
                                                                                </li>
                                                                                <li>
                                                                                    <a href="/FixedAmount" className="text-white"><em class="icon ni ni-shield-star-fill text-white"></em><span>مبلغ ثابت جهت قرارداد</span></a>
                                                                                </li>
                                                                                <li style={{ boxShadow: "0 0 25px -12px rgba(31, 43, 58, 0.15)", backgroundColor: "#fff" }}>
                                                                                    <a href="/InsuranceTaxSettings" style={{ boxShadow: "0 0 25px -12px rgba(31, 43, 58, 0.15)" }} ><em class="icon ni ni-activity-round-fill"></em><span>سایر تنظیمات بیمه و مالیات</span></a>
                                                                                </li>
                                                                            </ul>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="simplebar-placeholder" style={{ width: 'auto', height: '376px' }} >
                                                        </div>
                                                    </div>
                                                    <div class="simplebar-track simplebar-horizontal" style={{ visibility: 'hidden' }} >
                                                        <div class="simplebar-scrollbar" style={{ width: '0px', display: 'none' }} >
                                                        </div>
                                                    </div>
                                                    <div class="simplebar-track simplebar-vertical" style={{ visibility: 'hidden' }} >
                                                        <div class="simplebar-scrollbar" style={{ height: '0px', display: 'none' }} >
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>



                    </div>
                </div>
            </div>





        </div >

    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}